/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface InputEventOffsetUSMarker {
  size?: number,
  borderColor?: string,
  fillColor?: string
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic with Offset for input events of the asset
 *
 * ```typescript
 *  import {getInputEventOffsetUSMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getInputEventOffsetUSMarker({size, fillColor}),
 *    width  : size,
 *    height : size,
 *    angle  : 0
 * }
 * ```
 */
export const getInputEventOffsetUSMarker = ({
  fillColor = dlsColor('electricPurple'),
  borderColor = dlsColor('white'),
  size = 48
}: InputEventOffsetUSMarker) => {
  const svg = (`
    <svg width='${size}' height='${size}' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_434_79)'>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M36.2 13.2C30.2353 13.2 25.4 18.0353 25.4 24C25.4 29.9647 30.2353 34.8 36.2 34.8C42.1647 34.8 47 29.9647 47 24C46.9934 18.0381 42.162 13.2066 36.2 13.2Z' fill='${borderColor}'/>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M36.2 33C41.1705 33 45.2 28.9705 45.2 24C45.2 19.0294 41.1705 15 36.2 15C31.2294 15 27.2 19.0294 27.2 24C27.2056 28.9683 31.2317 32.9944 36.2 33Z' fill='${fillColor}'/>
        <path d='M36.2 33C41.1705 33 45.2 28.9706 45.2 24C45.2 19.0294 41.1705 15 36.2 15C31.2294 15 27.2 19.0294 27.2 24C27.2 28.9706 31.2294 33 36.2 33Z' fill='#C629DD'/>
        <path d='M33.5 19.5C32.6797 19.9538 31.998 20.609 31.5238 21.3992C31.0497 22.1894 30.8 23.0866 30.8 24C30.8 24.9134 31.0497 25.8106 31.5238 26.6008C31.998 27.391 32.6797 28.0461 33.5 28.5' stroke='white' stroke-width='2' stroke-miterlimit='10' stroke-linecap='round'/>
        <path d='M38.9 19.5C39.7203 19.9538 40.402 20.609 40.8761 21.3992C41.3502 22.1894 41.6 23.0866 41.6 24C41.6 24.9134 41.3502 25.8106 40.8761 26.6008C40.402 27.391 39.7203 28.0461 38.9 28.5' stroke='white' stroke-width='2' stroke-miterlimit='10' stroke-linecap='round'/>
        <path d='M36.2 25.8C37.1941 25.8 38 24.9941 38 24C38 23.0059 37.1941 22.2 36.2 22.2C35.2059 22.2 34.4 23.0059 34.4 24C34.4 24.9941 35.2059 25.8 36.2 25.8Z' fill='${borderColor}' stroke='white'/>
      </g>
      <defs>
        <clipPath id='clip0_434_79'>
          <rect width='21.6' height='21.6' fill='${borderColor}' transform='translate(25.4 13.2)'/>
        </clipPath>
      </defs>
    </svg>
  `);
  return convertSvgToDataUri(svg.trim());
};

export default getInputEventOffsetUSMarker;
